import {
  ProbationReviewActionError,
  ProbationReviewAuditAction,
  ProbationReviewAuditOperation,
  ProbationReviewCompletionMethod,
  ProbationReviewFlag,
  ProbationReviewOutcome,
  ProbationReviewReviewStatus,
  ProbationStatus,
} from '@/common/graphql';

export const ProbationReviewAuditActionLabels: Record<ProbationReviewAuditAction, string> = {
  [ProbationReviewAuditAction.SaveDraft]: 'Save draft',
  [ProbationReviewAuditAction.SubmitReview]: 'Submit review',
  [ProbationReviewAuditAction.MarkAsComplete]: 'Mark as Complete',
  [ProbationReviewAuditAction.RecordOutcome]: 'Record Outcome',
  [ProbationReviewAuditAction.ExtendProbation]: 'Extend Probation',
  [ProbationReviewAuditAction.ReassignReviewer]: 'Reassign reviewer',
};

export const ProbationReviewAuditOperationLabels: Record<ProbationReviewAuditOperation, string> = {
  [ProbationReviewAuditOperation.Insert]: 'Added',
  [ProbationReviewAuditOperation.Update]: 'Changed',
  [ProbationReviewAuditOperation.Delete]: 'Deleted',
};

export const ProbationReviewOutcomeLabels: Record<ProbationReviewOutcome, string> = {
  [ProbationReviewOutcome.Passed]: 'Passed',
  [ProbationReviewOutcome.Failed]: 'Failed',
};

export const ProbationReviewReviewStatusLabels: Record<ProbationReviewReviewStatus, string> = {
  [ProbationReviewReviewStatus.Draft]: 'Draft',
  [ProbationReviewReviewStatus.Submitted]: 'Submitted',
  [ProbationReviewReviewStatus.MarkAsCompleted]: 'Mark as Completed',
};

export const ProbationReviewCompletionMethodLabels: Record<ProbationReviewCompletionMethod, string> = {
  [ProbationReviewCompletionMethod.SubmittedInMed]: 'Submitted in MED',
  [ProbationReviewCompletionMethod.CompletedOffline]: 'Completed Offline',
  [ProbationReviewCompletionMethod.LegacyRecord]: 'Legacy Record',
};

export const ProbationStatusLabels: Record<ProbationStatus, string> = {
  [ProbationStatus.NotStarted]: 'Not Started',
  [ProbationStatus.InProgress]: 'In Progress',
  [ProbationStatus.Over]: 'Over',
};

export const ProbationReviewFlagLabels: Record<ProbationReviewFlag, string> = {
  [ProbationReviewFlag.Overdue]: 'Overdue',
  [ProbationReviewFlag.DueSoon]: 'Due Soon',
  [ProbationReviewFlag.Extended]: 'Extended',
};

/** Why an action skipped an employee (Mark as Complete and the other bulk actions). */
export const ProbationReviewActionErrorLabels: Record<ProbationReviewActionError, string> = {
  [ProbationReviewActionError.NotPermitted]: 'Not permitted',
  [ProbationReviewActionError.EmployeeHasLeft]: 'Has left the company',
  [ProbationReviewActionError.NoDraftReview]: 'No draft review',
  [ProbationReviewActionError.InvalidCompletionMethod]: 'Invalid completion method',
  [ProbationReviewActionError.EmployeeNotFound]: 'Probation review not found',
};
